const initialState = {
    pending: false,
    sensors: [],
    antennas: [],
    page: 0,
    itemsCount: 0,
    pageCount: 0,
    error: null,
    filters: {active: 'ALL', itemsPerPage: 3, search: '', lat: null, lon: null},
    selected: {},
    sensorTypes: [],
    details: null,
    detailsPending: false,
    sensorsDetailsPending: false,
    sensorsCalibrationDetailsPending: false,
    updateTimes: [],
    updateTimeStatus: null,
    sensorUpdateTypes: [],
    sensorAlertRules: [],
    sensorCalibrationValues: []
};

const sensorsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_SENSORS_PENDING':
            return {
                ...state,
                pending: true
            };
        case 'GET_SENSORS_DETAILS_PENDING':
            return {
                ...state,
                sensorsDetailsPending: true
            };
        case 'GET_SENSORS_DETAILS_SUCCESS':
            return {
                ...state,
                sensorsDetailsPending: false
            };
        case 'GET_SENSORS_CALIBRATION_DETAILS_PENDING':
            return {
                ...state,
                sensorsCalibrationDetailsPending: true
            };
        case 'GET_SENSORS_CALIBRATION_DETAILS_SUCCESS':
            return {
                ...state,
                sensorsCalibrationDetailsPending: false
            };
        case 'GET_SENSORS_SUCCESS':
            return {
                ...state,
                pending: false,
                sensors: action.sensors,
                page: action.page,
                pageCount: action.pageCount,
                itemsCount: action.itemsCount,
                sensorTypes: action.sensorTypes,
                antennas: action.antennas,
            };
        case 'GET_SENSORS_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        case 'SELECT_SENSOR':
            return {
                ...state,
                selected: action.selected
            };
        case 'SET_SENSORS_FILTERS':
            return {
                ...state,
                filters: action.filters
            };
        case 'GET_SENSOR_UPDATE_TIMES':
            return {
                ...state,
                updateTimes: action.updateTimes
            }
        case 'GET_SENSOR_UPDATE_TYPES':
            return {
                ...state,
                sensorUpdateTypes: action.sensorUpdateTypes
            }
        case 'GET_SENSOR_CALIBRATION_VALUES':
            return {
                ...state,
                sensorCalibrationValues: action.sensorCalibrationValues
            }
        case 'GET_SENSOR_ALERT_RULES':
            return {
                ...state,
                sensorAlertRules: action.sensorAlertRules
            }
        case 'GET_SENSOR_ALERT_RULES_OPTIONS':
            return {
                ...state,
                sensorAlertRulesOptions: action.sensorAlertRulesOptions
            }
        case 'GET_SENSOR_TEMPERATURE_CONFIG_LIST':
            return {
                ...state,
                sensorTemperatureConfigs: action.sensorTemperatureConfigs
            }
        case 'GET_SENSOR_TEMPERATURE_CONFIG_LIST_OPTIONS':
            return {
                ...state,
                sensorTemperatureConfigsOptions: action.sensorTemperatureConfigsOptions
            }
        case 'GET_COLD_SENSOR_TEMPERATURE_CONFIG_LIST':
            return {
                ...state,
                sensorColdTemperatureConfigs: action.sensorColdTemperatureConfigs
            }
        case 'GET_COLD_SENSOR_TEMPERATURE_CONFIG_LIST_OPTIONS':
            return {
                ...state,
                sensorColdTemperatureConfigsOptions: action.sensorColdTemperatureConfigsOptions
            }
        case 'SET_SENSOR_UPDATE_TIME_STATUS':
            return {
                ...state,
                updateTimeStatus: action.updateTimeStatus
            }
        case 'GET_SENSOR_DETAILS_PENDING':
            return {
                ...state,
                detailsPending: true
            };
        case 'GET_SENSOR_DETAILS_SUCCESS':
            return {
                ...state,
                detailsPending: false,
                details: action.details
            };
        case 'GET_SENSOR_DETAILS_ERROR':
            return {
                ...state,
                detailsPending: false,
                error: action.error
            };
        default:
            return state;
    }
};

export default sensorsReducer;
